import React from 'react';

export const Xls = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width ?? '44'}
    height={height ?? '45'}
    viewBox="0 0 44 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.89191 4.12551L29.5445 0.510205C29.7006 0.489708 29.8596 0.500166 30.0109 0.54087C30.1622 0.581574 30.3021 0.651572 30.4212 0.746121C30.5403 0.84067 30.6359 0.957561 30.7013 1.08887C30.7668 1.22018 30.8007 1.36284 30.8007 1.50718V43.4931C30.8006 43.6373 30.7668 43.7797 30.7015 43.9109C30.6361 44.042 30.5408 44.1588 30.4219 44.2533C30.3031 44.3478 30.1634 44.4179 30.0124 44.4587C29.8614 44.4996 29.7026 44.5103 29.5467 44.4901L1.88971 40.8748C1.36529 40.8064 0.885438 40.5671 0.538288 40.2008C0.191138 39.8345 5.083e-06 39.3658 0 38.8808V6.11947C5.083e-06 5.6345 0.191138 5.16582 0.538288 4.79952C0.885438 4.43322 1.36529 4.19389 1.88971 4.12551H1.89191ZM33.0006 4.37325H41.8001C42.3836 4.37325 42.9431 4.58545 43.3557 4.96316C43.7682 5.34088 44 5.85317 44 6.38735V38.6129C44 39.1471 43.7682 39.6594 43.3557 40.0371C42.9431 40.4148 42.3836 40.627 41.8001 40.627H33.0006V4.37325ZM18.0413 22.5001L24.201 14.4437H18.9213L15.4014 19.048L11.8816 14.4437H6.60187L12.7616 22.5001L6.60187 30.5565H11.8816L15.4014 25.9523L18.9213 30.5565H24.201L18.0413 22.5001Z"
      fill={color || '#449A37'}
    />
  </svg>
);
